import TagManager from 'react-gtm-module';

import { Logger } from '@montugroup/utilities';

import type { GTMType } from '@/tracking/TrackingTypes';

const logger = new Logger('googleTagManager.ts');

function configureGTM({
  googleTagManagerId,
  googleTagManagerAuth,
  googleTagManagerPreview,
}: {
  googleTagManagerId: string;
  googleTagManagerAuth: string;
  googleTagManagerPreview?: string;
}) {
  let initialised = false;
  const init = () => {
    if (googleTagManagerId) {
      logger.debug(`Initializing GoogleTagManager`);
      TagManager.initialize({
        gtmId: googleTagManagerId,
        auth: googleTagManagerAuth || '',
        preview: googleTagManagerPreview || '',
      });
      initialised = true;
    }
  };

  init();

  return (id: number, data: GTMType) => {
    if (initialised) {
      // logger.debug(`Tracking Event: ${event}`);

      const { stepName, ...rest } = data;

      TagManager.dataLayer({
        dataLayer: {
          step_number: id,
          step_name: stepName,
          ...rest,
        },
      });
    } else {
      init();
    }
  };
}

export default configureGTM;
